var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamsAddTeamMember({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8431",
    "data-name": "Rectangle 8431",
    width: 28.861,
    height: 30.276,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8433",
    "data-name": "Rectangle 8433",
    width: 10.775,
    height: 10.775,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8434",
    "data-name": "Rectangle 8434",
    width: 15.732,
    height: 23.889,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16130",
    "data-name": "Group 16130",
    transform: "translate(-1029 -1029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16096",
    "data-name": "Group 16096",
    transform: "translate(1034.08 1034.772)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16095",
    "data-name": "Group 16095",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5868",
    "data-name": "Path 5868",
    d: "M28.861,15.195a.964.964,0,0,1-.963.963H25.219v2.678a.963.963,0,0,1-1.927,0V16.158H20.615a.963.963,0,0,1,0-1.927h2.678V11.553a.963.963,0,0,1,1.927,0v2.678h2.7a.963.963,0,0,1,.938.963m-17.93-.6a7.3,7.3,0,1,0-7.3-7.3,7.3,7.3,0,0,0,7.3,7.3m0,1.959c-5.5,0-9.428,3.179-10.917,9.588a.643.643,0,0,0,.206.61,17.267,17.267,0,0,0,10.7,3.526A17.243,17.243,0,0,0,21.61,26.748a.643.643,0,0,0,.206-.61c-1.464-6.409-5.395-9.588-10.885-9.588",
    transform: "translate(0 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_264",
    "data-name": "Ellipse 264",
    transform: "translate(1029 1029)",
    fill: "#ebf7ff",
    stroke: "#0082ca",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.25,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16101",
    "data-name": "Group 16101",
    transform: "translate(-76.469 171)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_265",
    "data-name": "Ellipse 265",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(1130.468 858)",
    fill: "#0082ca"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16100",
    "data-name": "Group 16100",
    transform: "translate(1133.581 861.113)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16099",
    "data-name": "Group 16099",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5872",
    "data-name": "Path 5872",
    d: "M10.775,5.387A1.127,1.127,0,0,1,9.648,6.514H6.514V9.648a1.127,1.127,0,1,1-2.254,0V6.514H1.127a1.127,1.127,0,0,1,0-2.254H4.26V1.127a1.127,1.127,0,0,1,2.254,0V4.26H9.678a1.127,1.127,0,0,1,1.1,1.127",
    transform: "translate(0 0)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16103",
    "data-name": "Group 16103",
    transform: "translate(1042.133 1037.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16102",
    "data-name": "Group 16102",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5873",
    "data-name": "Path 5873",
    d: "M10.966,8.81a4.95,4.95,0,1,0-6.205,0A7.866,7.866,0,0,0,0,16.023v6.992a.873.873,0,0,0,.874.874H14.858a.873.873,0,0,0,.874-.874V15.948A7.913,7.913,0,0,0,10.966,8.81m-6.3-3.857a3.2,3.2,0,1,1,3.2,3.2,3.218,3.218,0,0,1-3.2-3.2m9.323,17.189H1.748V16.023a6.118,6.118,0,0,1,12.236-.058Z",
    transform: "translate(0 0)",
    fill: "#0082ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5874",
    "data-name": "Path 5874",
    d: "M11.615,5.157a3.2,3.2,0,1,1-3.2-3.2,3.217,3.217,0,0,1,3.2,3.2",
    transform: "translate(-0.545 -0.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5875",
    "data-name": "Path 5875",
    d: "M14.188,17.122V23.3H1.952V17.18a6.118,6.118,0,0,1,12.236-.058",
    transform: "translate(-0.204 -1.157)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamsAddTeamMember);
export default __webpack_public_path__ + "static/media/teams-add-team-member.17f09ecb668473f9538bb3d6d915c139.svg";
export { ForwardRef as ReactComponent };